module.exports = __webpack_public_path__ + "img/e-seminar.93b0b11.webp";